import LocalImages from "assets/images/local-images";
import Content, { ContentNS } from "content/content";
import ConfirmButton from "features/shared/components/buttons/ConfirmButton.styled";
import useGeneralAnalytics from "features/shared/hooks/analytics/useGeneralAnalytics";
import { Summary } from "features/shared/styles/typography/Summary.styled";
import { TertiaryHeader } from "features/shared/styles/typography/TertiaryHeader.styled";
import { FC, useEffect } from "react";
import NativeBridge from "services/native-bridge/native-bridge";
import { useAppStore } from "store/store";

// @ts-expect-error - This is how we utilize dynamic imports with WebPack NormalModuleReplacementPlugin
// See configuration in webpack.config.js
import IneligibleContainer from "./styles/IneligibleContainer-APP_CLIENT.styled";
import Header from "features/layout/components/header/Header";
import LayoutContainer from "features/layout/styles/LayoutContainer.styled";
import OutletContainer from "features/layout/styles/OutletContainer.styled";
import Container from "features/shared/styles/container/Container.styled";

const Ineligible: FC = () => {
  useGeneralAnalytics();

  const reason = useAppStore((state) => state.ineligibilityReason);
  const reasonText = reason ? `\n\n(${reason})` : "";

  const title = Content.shared.t("ineligible.title", { ns: ContentNS.ui });

  const description =
    Content.shared.t("ineligible.description", {
      ns: ContentNS.ui,
    }) + reasonText;

  const linkTitle = Content.shared.t("ineligible-button", { ns: ContentNS.ui });
  const returnUrl = useAppStore((state) => state.returnUrl);

  useEffect(() => {
    const loader = document.getElementById("init-loader-container");
    loader?.style.setProperty("display", "none");

    NativeBridge.shared.closeFlow("ineligible");
  }, []);

  return (
    <LayoutContainer>
      <Header />
      <OutletContainer>
        <Container id="app-content">
          <IneligibleContainer>
            <img
              alt="not found icon"
              src={LocalImages.shared.images.icons.notFound}
            />
            {title ? <TertiaryHeader>{title}</TertiaryHeader> : null}
            <Summary>{description}</Summary>
            {returnUrl !== null && !NativeBridge.shared.isEmbedded ? (
              <a href={returnUrl}>
                <ConfirmButton>{linkTitle}</ConfirmButton>
              </a>
            ) : null}
          </IneligibleContainer>
        </Container>
      </OutletContainer>
    </LayoutContainer>
  );
};

export default Ineligible;
